import { render } from "./PackagesStatusOverview.vue?vue&type=template&id=44698f2c&scoped=true"
import script from "./PackagesStatusOverview.vue?vue&type=script&lang=js"
export * from "./PackagesStatusOverview.vue?vue&type=script&lang=js"

import "./PackagesStatusOverview.vue?vue&type=style&index=0&id=44698f2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44698f2c"]])

export default __exports__